import React from 'react'

function Footer() {
    const currentYear = new Date().getFullYear();
    
    return (
        <footer className="bg-[#0f072c]">
            <div className="w-full mx-auto max-w-screen-xl p-4 flex flex-col items-center justify-center md:flex-row md:justify-between">
                <span className="text-sm text-gray-500 text-center dark:text-gray-400">© {currentYear} <a href="https://algoart.io" className="hover:underline">ALGOARTS™ All rights reserved</a>. ALGOARTS™ is a trademark of ALGOARTS Private Limited.</span>
                <ul className="flex flex-col items-center mt-3 text-sm font-medium text-gray-500 dark:text-gray-400 sm:mt-0 md:flex-row md:mt-0 md:items-center">
                    {/* <li className="mb-2 md:mb-0">
                        <a href="#" className="hover:underline me-4 md:me-6">About</a>
                    </li>
                    <li className="mb-2 md:mb-0">
                        <a href="#" className="hover:underline me-4 md:me-6">Privacy Policy</a>
                    </li>
                    <li className="mb-2 md:mb-0">
                        <a href="#" className="hover:underline me-4 md:me-6">Code of conduct</a>
                    </li>
                    <li>
                        <a href="#" className="hover:underline">Contact</a>
                    </li> */}
                </ul>
            </div>
        </footer>

    )
}

export default Footer
